import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-section-block',
    templateUrl: './section-block.component.html',
    styleUrls: ['./section-block.component.scss'],
})
export class SectionBlockComponent {
    @Input() title: string = '';
}
